<script setup lang="ts">
import type {NuxtError} from '#app';

const props = defineProps<{error: NuxtError}>();

// 404 是主要情境(apex nginx 把未知 slug 的 404 交給 microsite fallback,見 ADR 0012),
// 其餘狀態碼共用一句通用文案。
const description = computed(() =>
    props.error.statusCode === 404 ? '這個網址不存在，或頁面已被移除。' : '網站發生錯誤，請稍後再試。'
);

// 回首頁前必須先清掉錯誤狀態,否則畫面仍停在錯誤頁。
// href 保留真實連結語意(no-JS / 爬蟲),點擊交給 clearError 導頁。
function backToHome(): Promise<void> {
    return clearError({redirect: '/'});
}
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center gap-4 bg-osn-white-00 px-6 text-center">
    <p class="text-6xl font-bold text-osn-yellow-01">{{ error.statusCode }}</p>
    <p class="text-base text-osn-grey-00">{{ description }}</p>
    <a href="/" class="text-base font-medium text-osn-blue-00 underline" @click.prevent="backToHome">回首頁</a>
  </div>
</template>
